/*
	DO NOT MODIFY MANUALLY
	Generated by: generateModel.ts
*/

import { EducationLevel, Gender, IdTypes, OccupationGroup } from '../types/utils';
import { CreateExperienceInput } from './create-experience-input';

export class CreateUserInput {
	address: string = ''

	addressZipcode: string = ''

	addressCity: string = ''

	addressCountry: string = ''

	availableCash: number = 0

	birthCity: string = ''

	birthDate: Date = new Date()

	cellphone: string = ''

	citizenship: string = ''

	employment: string = ''

	experience: Array<CreateExperienceInput> = []

	firstName: string = ''

	gender: Gender = Gender.FEMALE

	highestEducation: EducationLevel = EducationLevel.PRIMARY_EDUCATION

	idDocumentCountry: string = ''

	idDocumentNumber: string = ''

	idDocumentType: IdTypes = IdTypes.ID

	lastName: string = ''

	monthlySalary: number = 0

	notUSTax: boolean = false

	occupationGroup: OccupationGroup = OccupationGroup.PRIVATIER

	passportIssuingAgency: string = ''

	politicallyExposed: boolean = false

	prevEmployment: string = ''

	skipIdNow: boolean = false

	taxNumber: string = ''
}